var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.917 12.8195V17.7365C16.917 18.1712 16.7443 18.5881 16.4369 18.8954C16.1296 19.2028 15.7127 19.3755 15.278 19.3755H6.26351C5.82882 19.3755 5.41193 19.2028 5.10456 18.8954C4.79719 18.5881 4.62451 18.1712 4.62451 17.7365V8.72201C4.62451 8.28732 4.79719 7.87043 5.10456 7.56306C5.41193 7.25569 5.82882 7.08301 6.26351 7.08301H11.1805",
    stroke: "#8800FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4585 4.62451H19.3755V9.5415",
    stroke: "#8800FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L19.3755 4.62451",
    stroke: "#8800FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.113dcbcf.svg";
export { ForwardRef as ReactComponent };